var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"id":"mailqueuetable","hover":"","fixed":"","fields":_vm.fields,"items":_vm.mailqueue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }